import React from "react";
import styles from "./styles/AndonSystems.module.css";
import { Reveal } from "../Home/common/Reveal";

import img1 from "../../../images/andon1.jpg";
import img2 from "../../../images/andon2.jpg";

const items = [
  {
    title: "Production Monitor Display",
    image: img1,
    description:
      "Alliance Automation has industrial displays and andon systems that companies have implemented to complement and help drive their manufacturing processes. Our industrial LED products provide the perfect answer to all your communication needs in the industrial environment.",
  },
  {
    title: "Dot Matrix Display",
    image: img2,
    description:
      "Alarms in a shop floor can be displayed, Such that supervisor of the line can easily troubleshoot the alarm spot. Production break down time can be reduced",
  },
];

export default function AndonSystems() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Andon Systems</h2>
          <div className={styles.accent} aria-hidden="true" />
          <p className={styles.intro}>
            The term “Andon” refers to a visual system used to notify management, workers and maintenance of either process or quality problems.
          </p>
        </div>
        <div className={styles.grid}>
          {items.map((item, index) => (
            <Reveal key={item.title} delay={index * 100}>
              <article className={styles.card}>
                <div className={styles.imageWrapper}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className={styles.cardImage}
                    loading="lazy"
                  />
                </div>
                <h3 className={styles.cardTitle}>{item.title}</h3>
                <div className={styles.cardAccent} aria-hidden="true" />
                <p className={styles.cardDescription}>{item.description}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
